import React, { createContext, useContext, useReducer } from 'react'
import PropTypes from 'prop-types'

// Initial state
const initialState = {
  title: '',
  isBack: true
}

// Create context
export const CMSContext = createContext()

// Define action types (optional but recommended)
export const ACTIONS = {
  SET_TITLE: 'SET_TITLE'
}

// Reducer function
function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.SET_TITLE:
      return {
        ...state,
        title: action.payload
      }

    default:
      return state
  }
}

// Context Provider component
export function CMSProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <CMSContext.Provider value={{ state, dispatch }}>
      {children}
    </CMSContext.Provider>
  )
}

// Custom hook to use the context (optional but recommended)
export function useCMSContext() {
  const context = useContext(CMSContext)
  if (!context) {
    throw new Error('useCMSContext must be used within an AppProvider')
  }
  return context
}

CMSProvider.propTypes = {
  children: PropTypes.node
}
